import api from "../util/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { BuscarLancamentoBancarioModel } from "../models/lancamentoBancario/buscarLancamentoBancarioModel";
import { BuscarSaldoContaBancoModel } from "../models/lancamentoBancario/buscarSaldoContaBancoModel";
import { BuscarDetalheLancamentoFinanceiroContaFinanceiraModel } from "../models/lancamentoBancario/buscarDetalheLancamentoFinanceiroContaFinanceiraModel";
import { setLoading } from "../redux/slices/configuracoes/configuracoesSlice";
import { toastError, toastSucess } from "../util/toast";
import { setModalCadastrarLancamentoBancario, setModalDeletarLancamentoBancario } from "../redux/slices/lancamentoBancario/lancamentoBancarioSlice";

export const cadastrarTransferenciaBancaria = createAsyncThunk("/LancamentoBancario/CadastrarTransferenciaBancaria", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.post("/LancamentoBancario/CadastrarTransferenciaBancaria", payload.value);
    toastSucess("Tranferência bancária realizada com sucesso");
    dispatch(setModalCadastrarLancamentoBancario(false));
    dispatch(setLoading(false));

    dispatch(buscarLancamentoBancario(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const buscarLancamentoBancario = createAsyncThunk("/LancamentoBancario/BuscarLancamentoBancario", async (args: BuscarLancamentoBancarioModel) => {
  try {
    const data = await api.post("/LancamentoBancario/BuscarLancamentoBancario", args);
    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});

export const buscarSaldoContaBanco = createAsyncThunk("/LancamentoBancario/BuscarSaldoContaBanco", async (args: BuscarSaldoContaBancoModel) => {
  try {
    const data = await api.get("/LancamentoBancario/BuscarSaldoContaBanco", {
      params: args,
    });
    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});

export const buscarDetalheLancamentoFinanceiroContaFinanceira = createAsyncThunk(
  "/LancamentoBancario/BuscarDetalheLancamentoFinanceiroContaFinanceira",
  async (args: BuscarDetalheLancamentoFinanceiroContaFinanceiraModel) => {
    try {
      const data = await api.get("/LancamentoBancario/BuscarDetalheLancamentoFinanceiroContaFinanceira", {
        params: args,
      });
      return data.data.data;
    } catch (error: any) {
      throw new Error(error.response.data.Message);
    }
  }
);

export const buscarDetalheLancamentoFinanceiroTransferenciaBancaria = createAsyncThunk("/LancamentoBancario/BuscarDetalheLancamentoFinanceiroTransferenciaBancaria", async (idOrigem: number) => {
  try {
    const data = await api.get("/LancamentoBancario/BuscarDetalheLancamentoFinanceiroTransferenciaBancaria", {
      params: { idOrigem: idOrigem },
    });
    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});

export const atualizarTransferenciaBancario = createAsyncThunk("/LancamentoBancario/AtualizarLancamentoBancario", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.put("/LancamentoBancario/AtualizarLancamentoBancario", payload.value);
    toastSucess("Tranferência bancária atualizada com sucesso");
    dispatch(setModalCadastrarLancamentoBancario(false));
    dispatch(setLoading(false));

    dispatch(buscarLancamentoBancario(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const deletarLancamentoBancario = createAsyncThunk("/LancamentoBancario/DeletarLancamentoBancario", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.post("/LancamentoBancario/DeletarLancamentoBancario", {
      id: payload.value.id,
      tipoLancamento: payload.value.tipoLancamento,
      entidadeParaRemover: payload.value.entidadeParaRemover,
    });
    toastSucess("Tranferência bancária removida com sucesso");
    dispatch(setModalDeletarLancamentoBancario(false));
    dispatch(setLoading(false));

    dispatch(buscarLancamentoBancario(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});
